module.exports = __webpack_public_path__ + "static/media/img_home.f076803f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_home.jpg
// module id = 400
// module chunks = 4